module.exports = __webpack_public_path__ + "img/TCALCI_broad_female_95.6e2a1ab7.png";